// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "71e0de73f27f";
export const BUILD_VERSION_NUMBER = 52;
